module.exports = __webpack_public_path__ + "media/images/image-about-839f12f4ebc39dd510ac846d766d28b2.jpg";